/** On every API answer the maintenance page gives in place of the application (MaintenanceMode.cs). */
export const MAINTENANCE_HEADER = "X-Maintenance";

const RELOADED_AT = "lob-maintenance-reload";

/**
 * The maintenance page went up while this page was open. Its API answers say so, and a reload is what puts the page
 * in front of the reader — or, in a browser holding the bypass cookie, the application again.
 *
 * <p>At most once a minute, so a page the browser keeps serving from its cache cannot reload itself in a loop. With
 * no session storage there is no guard, and then it does not reload at all: a page left showing an error is better
 * than one that never stops reloading.</p>
 */
export function reloadOntoMaintenancePage(reload: () => void = () => window.location.reload()): boolean {
  try {
    const last = Number(sessionStorage.getItem(RELOADED_AT) ?? 0);
    if (Date.now() - last < 60_000) return false;
    sessionStorage.setItem(RELOADED_AT, String(Date.now()));
  } catch {
    return false;
  }
  reload();
  return true;
}
